import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormBulkOrgStructureAssignment from '../../components/orgStructureAssignments/FormBulkOrgStructureAssignment';

const BulkOrgStructureAssignment = () => (
    <WrapperSection>
        <GlobalBreadcrumbs />
        <FormBulkOrgStructureAssignment />
    </WrapperSection>
);

export default BulkOrgStructureAssignment;
